import type { FlagsSnapshot } from '@occc/data-flags';

type CommandCenterData = {
  features?: Record<string, boolean>;
};

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isCommandCenterData(value: unknown): value is CommandCenterData {
  return isPlainObject(value);
}

export function extractCommandCenter(customData: unknown): unknown {
  if (!isPlainObject(customData)) return undefined;
  return customData.commandCenter;
}

export function parseFeatureFlags(commandCenter: unknown): FlagsSnapshot {
  if (!isPlainObject(commandCenter)) return {};

  const { features } = commandCenter;
  if (!isPlainObject(features)) return {};

  const result: Record<string, boolean> = {};

  for (const [key, value] of Object.entries(features)) {
    if (typeof value === 'boolean') {
      result[key] = value;
    }
  }

  return result;
}

export function extractFeatureFlag(
  commandCenter: unknown,
  flagKey: string,
  defaultValue: boolean,
): boolean {
  if (!isCommandCenterData(commandCenter)) return defaultValue;
  const value = commandCenter.features?.[flagKey];
  return typeof value === 'boolean' ? value : defaultValue;
}
